<script setup>
import { ref } from 'vue'

defineProps({
  content: { type: Object, required: true },
  variant: { type: String, default: 'nav-01' },
})

const menuOpen = ref(false)
</script>

<template>
  <nav class="b2-nav" :class="`variant-${variant}`">
    <div class="b2-nav-inner">
      <div class="b2-nav-logo">{{ content.nav_logo.value }}</div>
      <ul class="b2-nav-links">
        <li v-for="link in content.nav_links.value" :key="link">
          <a :href="'#' + link.toLowerCase()">{{ link }}</a>
        </li>
      </ul>
      <a href="#contact" class="b2-nav-cta">Get a Quote</a>
      <button class="b2-nav-burger" type="button" @click="menuOpen = !menuOpen">&#9776;</button>
    </div>
    <div class="b2-nav-mobile" :class="{ open: menuOpen }">
      <a
        v-for="link in content.nav_links.value"
        :key="link"
        :href="'#' + link.toLowerCase()"
        @click="menuOpen = false"
      >{{ link }}</a>
      <a href="#contact" class="b2-nav-cta-mobile" @click="menuOpen = false">Get a Quote</a>
    </div>
  </nav>
</template>

<style scoped>
.b2-nav { background: #1a3320; }
.b2-nav-inner { max-width: 1200px; margin: 0 auto; padding: 20px 40px; display: flex; align-items: center; gap: 32px; }
.b2-nav-logo { font-family: 'Playfair Display', serif; font-size: 22px; color: white; white-space: nowrap; }
.b2-nav-links { display: flex; gap: 28px; list-style: none; margin-left: auto; }
.b2-nav-links a { text-decoration: none; font-size: 13px; font-weight: 500; letter-spacing: .06em; text-transform: uppercase; color: rgba(255,255,255,.85); transition: color .2s; }
.b2-nav-links a:hover { color: #4a8c3f; }
.b2-nav-cta { background: #4a8c3f; color: white !important; padding: 10px 22px; border-radius: 2px; text-decoration: none; font-size: 13px; font-weight: 500; letter-spacing: .06em; text-transform: uppercase; white-space: nowrap; transition: background .2s; }
.b2-nav-cta:hover { background: #3a6e30; }
.b2-nav-burger { display: none; background: none; border: none; font-size: 24px; cursor: pointer; color: white; margin-left: auto; }
.b2-nav-mobile { display: none; flex-direction: column; background: white; padding: 20px 40px; gap: 16px; }
.b2-nav-mobile.open { display: flex; }
.b2-nav-mobile a { text-decoration: none; color: #1a3320; font-size: 16px; font-weight: 500; }
.b2-nav-cta-mobile { background: #4a8c3f; color: white !important; padding: 12px; text-align: center; border-radius: 2px; }
.variant-nav-02 { background: white; border-bottom: 1px solid #e4ebe2; }
.variant-nav-02 .b2-nav-logo, .variant-nav-02 .b2-nav-links a, .variant-nav-02 .b2-nav-burger { color: #1a3320; }
.variant-nav-02 .b2-nav-cta { border-radius: 999px; }
.variant-nav-03 .b2-nav-inner { justify-content: center; flex-wrap: wrap; padding-top: 18px; padding-bottom: 18px; }
.variant-nav-03 .b2-nav-logo { width: 100%; text-align: center; font-size: 25px; }
.variant-nav-03 .b2-nav-links { margin-left: 0; }
.variant-nav-03 .b2-nav-cta { position: absolute; right: max(20px, calc((100% - 1120px) / 2)); }
@media (max-width: 768px) {
  .b2-nav-links, .b2-nav-cta { display: none; }
  .b2-nav-burger { display: block; }
  .b2-nav-inner { padding: 16px 20px; }
  .variant-nav-03 .b2-nav-logo { width: auto; text-align: left; }
  .variant-nav-03 .b2-nav-cta { position: static; }
}
</style>
